<ds-tabs-group
    msThemedTabs
    [inverse]="false"
    [variant]="'horizontal'"
    [themedSize]="tabSize"
    [indicator]="indicator"
    [activeTab]="active.id"
    [size]="size"
    (tabChanged)="tabSelected.emit($event)">
    @for (tab of tabs; track tab.id) {
        <ds-tab [name]="tab.id">
            <ng-container *dsTabHeader="let selected">
                @if (!!tab.url) {
                    <a [msLink]="tab.url" [vnSpeculativeLink]="tab.url!">
                        <ng-container *ngTemplateOutlet="tabGroup; context: { tab: tab, selected: selected }" />
                    </a>
                } @else {
                    <ng-container *ngTemplateOutlet="tabGroup; context: { tab: tab, selected: selected }" />
                }
            </ng-container>
        </ds-tab>
    }
    @if (!showBorder) {
        <ds-divider />
    }
</ds-tabs-group>

<ng-template #tabGroup let-tab="tab" let-selected="selected">
    <span [attr.data-menu-item-id]="tab.id">
        {{ tab.title }}
        @if (!!tab.counter) {
            <ds-notification-bubble
                msThemedNotification
                [variant]="'neutral'"
                [disabled]="false"
                [size]="'medium'"
                [isSelected]="selected"
                [themedVariant]="counterVariant"
                [selectedVariant]="activeCounterVariant"
                [inverse]="false">
                {{ tab.counter }}</ds-notification-bubble
            >
        }
    </span>
</ng-template>
